import React from 'react';

import { SVGComponentProps } from './svg.types';

const LeaderSVG = ({ size = '1em', wrapperClass, ...otherProps }: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <mask id="path-1-inside-1" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48 14C48 6.26801 41.732 0 34 0H14C6.26801 0 0 6.26801 0 14V26C0 39.2548 10.7452 50 24 50C37.2548 50 48 39.2548 48 26V14Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48 14C48 6.26801 41.732 0 34 0H14C6.26801 0 0 6.26801 0 14V26C0 39.2548 10.7452 50 24 50C37.2548 50 48 39.2548 48 26V14Z"
          fill="#F8FFFC"
        />
        <path
          d="M14 3H34V-3H14V3ZM3 26V14H-3V26H3ZM24 47C12.402 47 3 37.598 3 26H-3C-3 40.9117 9.08831 53 24 53V47ZM45 26C45 37.598 35.598 47 24 47V53C38.9117 53 51 40.9117 51 26H45ZM45 14V26H51V14H45ZM34 3C40.0751 3 45 7.92487 45 14H51C51 4.61116 43.3888 -3 34 -3V3ZM14 -3C4.61116 -3 -3 4.61116 -3 14H3C3 7.92487 7.92487 3 14 3V-3Z"
          fill="#FFD321"
          mask="url(#path-1-inside-1)"
        />
        <path
          d="M14 3H34V-3H14V3ZM3 26V14H-3V26H3ZM24 47C12.402 47 3 37.598 3 26H-3C-3 40.9117 9.08831 53 24 53V47ZM45 26C45 37.598 35.598 47 24 47V53C38.9117 53 51 40.9117 51 26H45ZM45 14V26H51V14H45ZM34 3C40.0751 3 45 7.92487 45 14H51C51 4.61116 43.3888 -3 34 -3V3ZM14 -3C4.61116 -3 -3 4.61116 -3 14H3C3 7.92487 7.92487 3 14 3V-3Z"
          fill="#86E495"
          mask="url(#path-1-inside-1)"
        />
        <path
          d="M16.0459 13.0878L14 36.9033L15.2109 37L17.2568 13.1826C17.1483 13.1231 16.9429 13.0264 16.664 13.0041C16.383 12.9836 16.1641 13.045 16.0459 13.0878Z"
          fill="#1B792A"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M17.071 15.3493C17.5496 16.8167 18.0572 18.9835 17.9816 21.6189C17.875 25.3312 16.6603 28.1768 15.833 29.7558C16.8637 29.4117 18.4679 29.0063 20.4634 29.0081C22.4416 29.01 24.0322 29.4136 25.059 29.7558C25.7952 28.3181 26.6089 26.369 27.1282 23.979C27.7656 21.0367 27.721 18.4999 27.5428 16.6995C26.3958 16.1527 24.6037 15.4572 22.3021 15.1763C20.1205 14.9122 18.2955 15.1168 17.071 15.3493Z"
          fill="#86E495"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M27.589 20.8248C28.1257 21.0648 28.9743 21.3605 30.0476 21.3977C32.0218 21.4684 33.4652 20.624 33.9999 20.2725C33.2463 21.2991 31.8475 23.5142 31.551 26.622C31.3476 28.7665 31.7448 30.5222 32.0935 31.612C31.2352 31.2698 29.7512 30.8049 27.8641 30.8402C25.4346 30.8848 23.6367 31.7348 22.7861 32.2072L25.0607 29.7559C25.7 28.5061 26.38 26.9122 26.8838 25.0021C27.2926 23.4435 27.496 22.0263 27.589 20.8248Z"
          fill="#2BC545"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M22.6643 29.1774C22.6353 30.2449 22.6043 31.3125 22.5752 32.38C22.674 32.2908 22.8193 32.155 22.9898 31.9858C23.4528 31.5301 23.7318 31.199 24.0864 30.8029C24.315 30.5481 24.6444 30.1873 25.059 29.7558C24.6909 29.633 24.284 29.514 23.8423 29.408C23.4257 29.3094 23.0324 29.235 22.6643 29.1774Z"
          fill="#219735"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <mask
          id="mask0"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="48"
          height="50"
        >
          <mask id="path-7-inside-2" mask-type="luminance" fill="white">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M48 14C48 6.26802 41.732 0 34 0H14C6.26801 0 0 6.26801 0 14V26.9231C0 39.6681 10.7452 50 24 50C37.2548 50 48 39.6681 48 26.9231V14Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48 14C48 6.26802 41.732 0 34 0H14C6.26801 0 0 6.26801 0 14V26.9231C0 39.6681 10.7452 50 24 50C37.2548 50 48 39.6681 48 26.9231V14Z"
            fill="#FFF3E5"
          />
          <path
            d="M14 3H34V-3H14V3ZM3 26.9231V14H-3V26.9231H3ZM24 47C12.29 47 3 37.9014 3 26.9231H-3C-3 41.4348 9.2003 53 24 53V47ZM45 26.9231C45 37.9014 35.71 47 24 47V53C38.7997 53 51 41.4348 51 26.9231H45ZM45 14V26.9231H51V14H45ZM34 3C40.0751 3 45 7.92487 45 14H51C51 4.61116 43.3888 -3 34 -3V3ZM14 -3C4.61116 -3 -3 4.61115 -3 14H3C3 7.92486 7.92487 3 14 3V-3Z"
            fill="#EDC474"
            mask="url(#path-7-inside-2)"
          />
        </mask>
        <g mask="url(#mask0)">
          <rect
            opacity="0.2"
            x="-16"
            y="46"
            width="72"
            height="20"
            transform="rotate(-45 -16 46)"
            fill="white"
          />
        </g>
      </svg>
    </span>
  );
};

export default LeaderSVG;
